import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.7479 2.94711C16.5289 2.16607 17.7953 2.16607 18.5763 2.94711L21.0512 5.42199C21.8322 6.20304 21.8322 7.46937 21.0512 8.25042L16.4983 12.8031L15.0842 11.3889L16.5799 9.89322L14.105 7.41834L12.6092 8.91406L11.1951 7.49981L15.7479 2.94711ZM3.99991 2.58564L21.4141 19.9998L19.9999 21.4141L13.9435 15.3577L9.15772 20.1435L2.77797 21.2199L3.85442 14.8402L8.64023 10.0544L2.58569 3.99985L3.99991 2.58564ZM10.0544 11.4686L5.72027 15.8028L5.21793 18.78L8.19515 18.2776L12.5293 13.9435L10.0544 11.4686Z"}}]};

const EditOffFilled = Vue.extend<IconProps>({
  name: 'EditOffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'edit-off-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default EditOffFilled;
